/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';

// eslint-disable-next-line react/prefer-stateless-function
class TaskPanelHeader extends Component {
  render() {
    return (
      <div className="panel-heading">
        <div className="task-table">
          <div className="task-cell">
            <h2 className="h3 task-title" title={this.props.task.title}>
              {this.props.typeLayout === 'view' ? (
                this.props.task.title
              ) : (
                <NavLink
                  to={`/my-tasks/view/${this.props.task.id}`}
                  title={this.props.task.title}
                >
                  {this.props.task.title}
                </NavLink>
              )}
            </h2>
          </div>
          <div className="task-cell task-price">
            <div className="task-price-val">
              <span className="h3">{this.props.task.costExecution}</span> ₽
            </div>
          </div>
        </div>
        <ul className="list-inline task-info">
          <li className="text-muted">
            {formatter.dateFormat3(this.props.task.createdAt)}
          </li>
          <li className="text-muted">ID{this.props.task.id}</li>
          <li title={`http://${this.props.task.taskDomain}`}>
            <a
              className="text-success text-underline"
              target="_blank"
              rel="noopener noreferrer"
              href={`http://${this.props.task.taskDomain}`}
            >
              {this.props.task.taskDomain}
            </a>
          </li>
          <li>
            {' '}
            <i className="text-primary fa fa-thumbs-o-up" />{' '}
            <span className="text-muted">
              {this.props.task.taskCommentsStat.likes}
            </span>{' '}
            <i className="text-primary fa fa-thumbs-o-down" />{' '}
            <span className="text-muted">
              {this.props.task.taskCommentsStat.dislikes}
            </span>
          </li>
        </ul>
      </div>
    );
  }
}

TaskPanelHeader.defaultProps = {
  typeLayout: 'list'
};

TaskPanelHeader.propTypes = {
  typeLayout: PropTypes.oneOf(['list', 'view']),
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    taskDomain: PropTypes.string.isRequired,
    costExecution: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    taskCommentsStat: PropTypes.shape({
      dislikes: PropTypes.number.isRequired,
      likes: PropTypes.number.isRequired,
      neutral: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

export default withRouter(TaskPanelHeader);



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TaskPanelHeader/TaskPanelHeader.js